<template>
  <div class="">
    <create-note-template> </create-note-template>
  </div>
</template>

<script>
import CreateNoteTemplate from "@/components/profile/note-templates/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CreateNoteTemplate,
  },
  created() {
    this.notifyQueue({
      text: "Crea Template Nota",
      path: "note_templates.create",
      level: 3,
    });
  },
};
</script>
